import { forwardRef, type TextareaHTMLAttributes } from 'react'

import { cn } from '@/lib/utils/cn'

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full rounded-lg border border-slateish-300 bg-white px-3 py-2 text-sm text-ink-700 placeholder:text-slateish-400',
          'focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500',
          'aria-[invalid=true]:border-danger-500',
          className
        )}
        {...props}
      />
    )
  }
)
